// extracted by mini-css-extract-plugin
module.exports = {"reply":"MessageFileElm_reply__30tW8","file":"MessageFileElm_file__2KYHr","bigIcon":"MessageFileElm_bigIcon__1rYE-","smallIcon":"MessageFileElm_smallIcon__1Apt_"};